import { Box, Typography, TextField, IconButton } from '@mui/material';
import { useScreenLargerThan } from '../../lib/hooks/breakpoint-hooks';
import SearchIcon from '@mui/icons-material/Search';

type SearchBoxProps = {
    filterValue: string;
    page: string;
    setFilter: (filter: string) => void;
};

const SearchBox = ({ setFilter, filterValue, page }: SearchBoxProps) => {
    const isLargerThanSmall = useScreenLargerThan('sm');

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    marginBottom: '12px',
                    marginRight: isLargerThanSmall ? '0' : '12px'
                }}>
                <Typography sx={{ paddingRight: '12px' }}>Search</Typography>
                <TextField
                    size="small"
                    value={filterValue}
                    onChange={(v) => {
                        setFilter(v.target.value);
                    }}
                    placeholder={page === 'audit' ? 'Search by Case or MD' : 'Search by any column'}
                    InputProps={{
                        endAdornment: (
                            <IconButton>
                                <SearchIcon />
                            </IconButton>
                        )
                    }}
                />
            </Box>
        </>
    );
};

export default SearchBox;
